<div class="auth-layout-wrap" style="background-image: url(./assets/images/landing/Bg/bg2.jpg)">
    <div class="auth-content">
        <router-outlet></router-outlet>
    </div>
</div>